export default __webpack_public_path__ + "pr_dark.3305b807.svg";